import React from 'react';
import YouTube from '../../../commons/youtube';
import CikkProfilContent from './CikkProfilContent';

const videoData = [
  { text: 'Cikk profil', id: 'KAxQV77nCGQ' }
];

const CikkProfilBase = (props) => {
  let cardStyle = {
    padding: 20
  };

  return (
    <div className="animated fadeIn">
      <div className="card">
        <div className="card-header">
          Cikk profil
          {/* <YouTube data={videoData} /> */}
        </div>
        <div className="row" style={cardStyle}>
          <div className="col-md-12">
            <CikkProfilContent
              globals={props.route.globals}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CikkProfilBase;
